import { render } from "./SidebarNavAdmin.vue?vue&type=template&id=6bd4b212"
import script from "./SidebarNavAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarNavAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__